import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const workingYears = async (params: object) => {
  return await GET({ url: Api.workingYears, params, showError: false })
}
